import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@xxtract/ui';
import type { IntakeColumnMappingProposal } from '../intake.api';

export interface SamplePanelProps {
  column: IntakeColumnMappingProposal | null;
}

/**
 * h5-5: shows the same anonymized sample the AI saw (h5-2 PiiSanitizer output) — never raw cell
 * values with PII reach the browser.
 */
export function SamplePanel({ column }: SamplePanelProps) {
  const { t } = useTranslation();

  if (!column) {
    return (
      <Card data-testid="intake-sample-panel-empty">
        <CardContent className="py-6 text-sm text-[var(--foreground-muted)]">{t('intake.review.samplePanel.empty')}</CardContent>
      </Card>
    );
  }

  return (
    <Card data-testid="intake-sample-panel">
      <CardHeader>
        <CardTitle>{column.header}</CardTitle>
      </CardHeader>
      <CardContent>
        {column.sanitizedSampleValues.length === 0 ? (
          <p className="text-sm text-[var(--foreground-muted)]">{t('intake.review.samplePanel.noValues')}</p>
        ) : (
          <ul className="flex flex-col gap-1">
            {column.sanitizedSampleValues.map((value, index) => (
              <li key={index} className="rounded-[var(--radius-control)] bg-[var(--background-muted)] px-2 py-1 text-sm">
                {value}
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
